<div
  class="d-flex w-100"
  [ngClass]="{ 'border-top': y_borders, 'border-bottom': y_borders }"
  [style.paddingTop]="padding_top + 'px'"
  [style.paddingBottom]="padding_bottom + 'px'"
  [appStoryblok]="_editable"
>
  <div class="container-xl">
    <div class="row" style="--bs-gutter-x: 32px">
      <div
        [ngClass]="{
          'order-lg-1 border-start': reverse_order,
          'border-end': !reverse_order
        }"
        class="col-lg-{{ layout }} mb-5 mb-lg-0 col-12"
      >
        <div
          class="position-relative h-100"
          [style.paddingTop]="offset_top + '%'"
          [style.paddingLeft]="offset_left + '%'"
          [style.paddingRight]="offset_right + '%'"
          [style.paddingBottom]="offset_bottom + '%'"
        >
          <img
            [loaderParams]="{
              aspect: width / height
            }"
            class="w-100 h-auto"
            [height]="height"
            [width]="width"
            [ngSrc]="image.filename"
            *ngIf="image.filename"
          />
        </div>
      </div>
      <div
        class="col-12 col-lg-{{ 12 - layout }} d-flex flex-row"
        [ngClass]="[content_y, content_x]"
      >
        <div
          class="poster-content"
          [ngClass]="{ sticky: content_y === 'align-items-start' }"
          [style.maxWidth]="
            content_max_width ? content_max_width + 'px' : 'inherit'
          "
        >
          <div *ngIf="eyebrow" class="eyebrow">{{ eyebrow }}</div>
          <div *ngIf="content" class="mb-4" [storyblokRichText]="content"></div>
          <div *ngIf="actions.length > 0">
            <div class="me-2 d-inline-flex" *ngFor="let blok of actions">
              <ndc-dynamic
                *ngIf="components"
                [ndcDynamicComponent]="components[blok.component]"
                [ndcDynamicInputs]="blok"
              >
              </ndc-dynamic>
            </div>
          </div>
          <div *ngIf="accordions.length > 0">
            <div
              class="me-2 d-inline-flex w-100 accordion-host"
              *ngFor="let blok of accordions"
            >
              <ndc-dynamic
                *ngIf="components"
                [ndcDynamicComponent]="components[blok.component]"
                [ndcDynamicInputs]="blok"
              >
              </ndc-dynamic>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
